export const CURRENCY_CONFIG = {
    BTC: {
        decimals: 8,
        displayDecimals: 5,
        compactDecimals: 5,
        defaultStartingBalance: 0.05,
        minBet: 0.0000001,
        maxBet: 1,
        quickStakes: [0.0001, 0.001, 0.01],
    },
    ETH: {
        decimals: 6,
        displayDecimals: 4,
        compactDecimals: 4,
        defaultStartingBalance: 1,
        minBet: 0.000001,
        maxBet: 50,
        quickStakes: [0.01, 0.1, 1],
    },
    SOL: {
        decimals: 4,
        displayDecimals: 3,
        compactDecimals: 3,
        defaultStartingBalance: 25,
        minBet: 0.001,
        maxBet: 1000,
        quickStakes: [0.1, 1, 10],
    },
    USDT: {
        decimals: 2,
        displayDecimals: 2,
        compactDecimals: 2,
        defaultStartingBalance: 5000,
        minBet: 0.10,
        maxBet: 1_000_000,
        quickStakes: [10, 50, 100],
    },
    USD: {
        decimals: 2,
        displayDecimals: 2,
        compactDecimals: 2,
        defaultStartingBalance: 5000,
        minBet: 0.10,
        maxBet: 1_000_000,
        quickStakes: [10, 50, 100],
    },
};
/** Convenience: look up the config for a currency, with a defensive fall-back
 *  to BTC if a string sneaks in that doesn't match the enum. */
export function configForCurrency(c) {
    return CURRENCY_CONFIG[c] ?? CURRENCY_CONFIG.BTC;
}
//# sourceMappingURL=currency-config.js.map